// extracted by mini-css-extract-plugin
export default {"__":"home_____6I66q"};